import React from "react";
import QuoteTableSkeletonLoader from "../../../components/Quotes/Components/QuoteTableSkeletonLoader/QuoteTableSkeletonLoader";
import QuoteTableViewSwitcher from "../../../components/Quotes/Components/QuoteTableViewSwitcher/QuoteTableViewSwitcher";
import QuoteTableWrapper from "../../../components/Quotes/QuoteTable/QuoteTableWrapper";
import { QuoteTableView } from "../../../enums/QuoteTableView";
import sampleData from "../../../../utility/sampleData";
import Layout from "../../../components/Layout/Layout";
import Header from "../../../components/Header/Header";
import SortBy from "../../../enums/SortBy";

const QuoteTableStyleGuide: React.FC = () => {
    return (
        <Layout
            Header={(): React.ReactNode => (
                <Header>
                    <h1>Quote Table [H1]</h1>
                </Header>
            )}>
            <article className="layout-content-container">
                <div className="gap-xl">
                    <h3>View Switcher</h3>
                    <QuoteTableViewSwitcher
                        currentView={QuoteTableView.Details}
                        handleChangeQuoteTableView={(view) => alert(`Switch to: ${view}`)}
                    />
                </div>
                <div className="gap-xl">
                    {/* TODO: The wrapper is a placeholder for rapid development
                                    We should be using a static QuoteTableInfo model.
                                    https://lifedirect.atlassian.net/browse/LDS-4581
                                */}
                    <QuoteTableWrapper
                        cards={[
                            ...sampleData.sampleResultData,
                            ...sampleData.sampleResultData
                        ]}
                        handlePaymentFrequencyChange={async () =>
                            alert("Changed payment frequency")
                        }
                        sortBy={SortBy.LowestPrice}
                        clients={sampleData.sampleClientData}
                        handleClickCallToAction={async (productId) =>
                            alert(`Selected product - ID:${productId}`)
                        }
                        isAdmin={false}
                    />
                </div>
                <div>
                    <QuoteTableSkeletonLoader />
                </div>
            </article>
        </Layout>
    );
};

export default QuoteTableStyleGuide;
